import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { computed, defineComponent, reactive, onUnmounted } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { UserExamService } from '@/services/userExam.service';
import { useRouter, useRoute } from 'vue-router';
import { DaoService } from '@/services/dao.service';
import { USER_EXAM_PASSED, USER_EXAM_AWARDED, value2label, formatDateToSecond, preloadIDE, getBaseInfoText, ContestPlatformVals } from '@/utils';
import ExamInfoModal from '@/components/ExamInfoModal.vue';
import { environment, isInIframe } from '@/utils/environment';
import { winTopPostMessage } from '@/utils/topWindowBridge';
import ExamTicket from './ExamTicket.vue';
export default defineComponent({
  name: 'ContestTable',
  components: {
    ExamInfoModal: ExamInfoModal,
    ExamTicket: ExamTicket
  },
  props: {
    list: {
      type: Array
    }
  },
  setup: function () {
    var _this = this;
    var route = useRoute();
    var isNocFlag = computed(function () {
      return route.query.platform ? ContestPlatformVals.includes(route.query.platform) : false;
    });
    var columns = computed(function () {
      var firstColumn = {
        title: '活动ID',
        dataIndex: 'contestInfoId',
        key: 'contestInfoId',
        fixed: 'left'
      };
      var cols = [{
        title: isNocFlag.value ? '比赛信息' : '活动信息',
        key: 'contestInfo',
        slots: {
          customRender: 'contestInfo'
        },
        width: 200,
        fixed: 'left'
      }, {
        title: isNocFlag.value ? '比赛开始时间' : '考试开始时间',
        key: 'startTime',
        slots: {
          customRender: 'startTime'
        },
        width: 160
      }, {
        title: isNocFlag.value ? '比赛结束时间' : '考试结束时间',
        key: 'endTime',
        slots: {
          customRender: 'endTime'
        },
        width: 160
      }, {
        title: '组别',
        dataIndex: 'contestScheduledName',
        key: 'contestScheduledName',
        width: 200
      }, {
        title: isNocFlag.value ? '比赛阶段' : '活动阶段',
        dataIndex: 'contestStageName',
        key: 'contestStageName',
        width: 100
      }, {
        title: '得分',
        key: 'totalScore',
        slots: {
          customRender: 'totalScore'
        },
        width: 80
      }, {
        title: '晋级结果',
        key: 'passed',
        slots: {
          customRender: 'passed'
        },
        width: 80
      }, {
        title: '奖项',
        key: 'awarded',
        slots: {
          customRender: 'awarded'
        },
        width: 80
      }, {
        title: '操作',
        key: 'operation',
        fixed: 'right',
        slots: {
          customRender: 'operation'
        }
      }];
      return isNocFlag.value ? cols : __spreadArray([firstColumn], cols, true);
    });
    var router = useRouter();
    var userExamService = useService(UserExamService);
    var daoService = useService(DaoService);
    var checkDetail = function (item) {
      router.push({
        name: 'UserItemDetail',
        params: {
          id: item.userExamId
        },
        query: route.query
      });
    };
    var examInfo = reactive({
      userExamId: 0,
      visible: false,
      baseInfoText: '',
      answerRule: '',
      contestId: 0
    });
    var showExamInfo = function (item) {
      return __awaiter(_this, void 0, void 0, function () {
        var showAction;
        var _a;
        return __generator(this, function (_b) {
          if ((_a = item.userSupportCheck) === null || _a === void 0 ? void 0 : _a.deviceCheckConfig) {
            if (item.examType === 1) {
              daoService.preStartMockExam(item.userExamId).then(function () {
                goCheckDevice(item);
              });
            } else {
              goCheckDevice(item);
            }
            return [2 /*return*/];
          }
          showAction = function () {
            daoService.getExamInfo(item.userExamId).then(function (info) {
              examInfo.baseInfoText = getBaseInfoText(info.questionInfoList);
              examInfo.answerRule = info.answerRule;
              preloadIDE(); // 预加载ide
              examInfo.userExamId = item.userExamId;
              examInfo.visible = true;
              examInfo.contestId = item.contestInfoId;
            });
          };
          if (item.examType === 1) {
            // if (item.userExamId) {
            daoService.preStartMockExam(item.userExamId).then(function () {
              showAction();
            });
          } else {
            showAction();
          }
          return [2 /*return*/];
        });
      });
    };
    var onPaginationChange = function (pa) {
      userExamService.setPageNum(pa.current);
      userExamService.setPageSize(pa.pageSize);
      userExamService.search();
    };
    var pagination = computed(function () {
      return {
        showSizeChanger: true,
        total: userExamService.total,
        current: userExamService.pageNum,
        pageSize: userExamService.pageSize
      };
    });
    var goToItemDetail = function (item) {
      if (isNocFlag.value) return;
      router.push({
        name: 'ItemDetail',
        params: {
          id: item.contestInfoId
        },
        query: route.query
      });
    };
    var goToExamAnswer = function (item) {
      router.push({
        name: 'Examination',
        params: {
          id: item.userExamId,
          answerId: item.answerPaperId
        },
        query: route.query
      });
    };
    var getBtnText = function (item) {
      var hideGetCertification = environment === 'production' ? item.contestInfoId === 797 : item.contestInfoId === 36;
      if (item.examType === 1) {
        return '去模拟';
      }
      if (isNocFlag.value) {
        return '去比赛';
      }
      return item.activityId === 259 ? '去比赛' : hideGetCertification ? '参与活动' : '去考试';
    };
    onUnmounted(function () {
      userExamService.clearTimer();
    });
    var getRowClassName = function (record) {
      if (record.status === 1) {
        return 'row-ing';
      }
      if (record.status === 0 && record.endTime < Date.now()) {
        return 'row-ended';
      }
      return '';
    };
    var inIframe = isInIframe();
    var goCheckDevice = function (record) {
      var queryData = {
        id: record.userExamId,
        contestId: record.contestInfoId
      };
      var queryDataBase64 = window.btoa(JSON.stringify(queryData));
      if (inIframe) {
        winTopPostMessage({
          method: 'openUrlOnNewTab',
          data: {
            url: "".concat(location.origin, "/device-check?qs=").concat(queryDataBase64, "&from=YjJj")
          }
        });
      } else {
        var enableLiveMonitor = record.enableLiveMonitor;
        router.push({
          name: enableLiveMonitor ? 'EnvCheck' : 'DeviceCheck',
          query: __assign(__assign({}, route.query), {
            qs: queryDataBase64
          })
        });
      }
    };
    var goToAnswerPaper = function (item) {
      if (item.examType === 1) {
        router.push({
          name: 'Examination',
          params: {
            id: item.userExamId,
            answerId: item.answerPaperId,
            suffix: 'check'
          },
          query: __assign(__assign({}, route.query), {
            areaId: item.contestAreaId
          })
        });
      } else {
        goToRecorderPaper(item);
      }
    };
    var goToRecorderPaper = function (item) {
      router.push({
        name: 'Examination',
        params: {
          id: item.userExamId,
          answerId: item.answerPaperId,
          suffix: 'recorder'
        },
        query: __assign({}, route.query)
      });
    };
    var getExamTicket = function (item) {
      ExamTicketData.visible = true;
      ExamTicketData.userExamId = item.userExamId;
    };
    var ExamTicketData = reactive({
      visible: false,
      userExamId: 0
    });
    return {
      examInfo: examInfo,
      columns: columns,
      userExamService: userExamService,
      pagination: pagination,
      USER_EXAM_PASSED: USER_EXAM_PASSED,
      USER_EXAM_AWARDED: USER_EXAM_AWARDED,
      value2label: value2label,
      checkDetail: checkDetail,
      showExamInfo: showExamInfo,
      onPaginationChange: onPaginationChange,
      formatDateToSecond: formatDateToSecond,
      goToItemDetail: goToItemDetail,
      goToExamAnswer: goToExamAnswer,
      getBtnText: getBtnText,
      getRowClassName: getRowClassName,
      goCheckDevice: goCheckDevice,
      goToAnswerPaper: goToAnswerPaper,
      goToRecorderPaper: goToRecorderPaper,
      getExamTicket: getExamTicket,
      ExamTicketData: ExamTicketData
    };
  }
});